import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { EditResponsesPropertiesModalPage } from './edit-responses-properties-modal.page';

const routes: Routes = [
  {
    path: '',
    component: EditResponsesPropertiesModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [EditResponsesPropertiesModalPage]
})
export class EditResponsesPropertiesModalPageModule {}
